import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
@Injectable({ providedIn: 'root' })
export class LocationService {
    private locSubject: BehaviorSubject<any>;
    public loc$: Observable<any>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.locSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('apptInfo')));
        this.loc$ = this.locSubject.asObservable();
    }

    public get locInfo(): any {
        return this.locSubject.value;
    }
    setLocationInfo(locInfo)
    {
        localStorage.setItem('locInfo', JSON.stringify(locInfo));
        this.locSubject.next(locInfo);
    }

    GetNationalities() {
    return this.http.get<any>(`${environment.apiUrl}geo/nationality`);
    }

    GetCountries() {
        return this.http.get<any>(`${environment.apiUrl}geo/country`);
    }

    GetStates() {
        return this.http.get<any>(`${environment.apiUrl}geo/province`);
    }

    GetDistricts(State: string) {
        return this.http.get<any>(`${environment.apiUrl}geo/district/${State}`);
    }

    GetCities(District: string) {
        return this.http.get<any>(`${environment.apiUrl}geo/city/${District}`);
    }

    GetAllDepartment(LocationId: number) {
        return this.http.get<any>(
        `${environment.apiUrl}geo/department/${LocationId}`
        );
    }

    getMasterDataLocCode(LocationId: number) {
        return this.http.get<any>(
        `${environment.apiUrl}geo/getmasterdata_loc_acode/${LocationId}`
        );
    }

    GetDoctors(LocationId: number, DepartmentID: number) {
        return this.http.get<any>(
        `${environment.apiUrl}geo/doctor/${LocationId}/${DepartmentID}`
        );
    }
    
 
   
}